import { action } from 'typesafe-actions';

import { ClientTypes } from './types';

export const setCpfAnswered = (answered: boolean) => action(ClientTypes.SET_CPF_ANSWERED, answered);
